import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'paymentType',
	state : {
		paymentTypes: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/catalogs/payments_type') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				let query = {};
				if (localStorage.getItem('currentHotel')) 
					query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}

				const resp = yield call(all, 'PaymentType', {
					where: query,
					include: 'hotel', 
					skip: 0, 
					limit: limit, 
					count: 1, 
					order: '-createdAt'
				})
				const paymentTypes = resp.results;

				yield put({ type: 'queryFirst', payload: {
					paymentTypes: paymentTypes, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'hotel'};

				const resp = yield call(all, 'PaymentType', data)
				const paymentTypes = resp.results;

				yield put({ type: 'querySuccess', payload: {
					paymentTypes: paymentTypes,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*filter({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				const resp = yield call(all, 'PaymentType', {...payload, include: 'hotel'})
				const paymentTypes = resp.results;

				yield put({ type: 'filterSuccess', payload: {
					paymentTypes: paymentTypes,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: payload.hotel.objectId};

				if (data.parent_category)
					data.parent_category = {__type: 'Pointer', className: 'PaymentType', objectId: payload.parent_category.objectId};

				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'PaymentType', payload.objectId, data);
				yield put({ type: 'updateSuccess', payload: {...data, hotel: payload.hotel, objectId: payload.objectId} })
				message.success('Se ha actualizado el registro exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'PaymentType', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				paymentTypes: state.paymentTypes.concat(action.payload.paymentTypes),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				...state,
				paymentTypes: action.payload.paymentTypes,
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		createSuccess(state, action) {
			return {
				...state,
    			paymentTypes: [action.payload, ...state.paymentTypes]
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.paymentTypes, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			paymentTypes: _.without(state.paymentTypes, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/paymentType.js